module.exports = __webpack_public_path__ + "static/media/acr-centroid_mod.ade2d1ca.svg";